/* Nakylo · zone d'achat : effet d'ajout du bouton, barre d'achat collante, lecteur des vidéos clients.
   Rien ici ne décide d'un prix ni du contenu du panier : ce script ne fait que montrer et relayer. */
(function () {
  var moinsDeMouvement = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. « Ajouté ! » : le bouton confirme le geste ---------- */
  function feter() {
    document.querySelectorAll('.nky-cta').forEach(function (b) {
      var libelle = b.querySelector('span');
      if (!libelle || b.classList.contains('is-ajoute')) return;
      var avant = libelle.textContent;
      libelle.textContent = b.dataset.ajoute || avant;
      b.classList.add('is-ajoute');
      if (!moinsDeMouvement) {
        var disque = b.querySelector('.nky-cta__disque');
        for (var i = 0; i < 8; i++) {
          var point = document.createElement('i');
          point.className = 'nky-cta__eclat';
          var angle = (Math.PI * 2 * i) / 8 + 0.3;
          point.style.setProperty('--dx', Math.cos(angle) * 30 + 'px');
          point.style.setProperty('--dy', Math.sin(angle) * 30 + 'px');
          (disque || b).appendChild(point);
          setTimeout(function (p) { p.remove(); }, 700, point);
        }
      }
      setTimeout(function () { b.classList.remove('is-ajoute'); libelle.textContent = avant; }, 1800);
    });
  }
  document.addEventListener('nky:ajoute', feter);
  /* ajout classique par Dawn (page sans offres) */
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.source === 'product-form') feter(); });
  }

  /* ---------- 2. barre d'achat collante ---------- */
  function brancherSticky() {
    var barre = document.querySelector('[data-nky-sticky]');
    if (!barre || barre.dataset.nkyPret) return;
    barre.dataset.nkyPret = '1';
    var zone = barre.closest('product-info') || barre.closest('.shopify-section') || document;
    document.body.appendChild(barre);                 /* hors des parents animés, sinon fixed ne tient pas */
    var bouton = barre.querySelector('[data-nky-sticky-bouton]');
    var elTitre = barre.querySelector('[data-nky-sticky-titre]');
    var elPrix = barre.querySelector('[data-nky-sticky-prix]');
    var elBarre = barre.querySelector('[data-nky-sticky-barre]');
    var titreProduit = elTitre ? elTitre.textContent : '';
    var force = false;                                /* éditeur : bloc sélectionné → barre visible */
    var toujours = barre.hasAttribute('data-nky-sticky-toujours');
    document.body.classList.toggle('nky-sticky-toujours', toujours);   /* place en bas de page pour ne rien cacher */

    function offreActive() {
      var r = zone.querySelector('.nky-offre .nky-offre__radio:checked');
      return r ? r.closest('.nky-offre') : null;
    }
    function majContenu() {
      var o = offreActive();
      if (!o) return;
      var t = o.querySelector('.nky-offre__titre'), p = o.querySelector('[data-nky-prix]'), s = o.querySelector('[data-nky-barre]');
      if (elTitre) elTitre.textContent = t ? t.textContent.trim() : titreProduit;
      if (elPrix && p) elPrix.textContent = p.textContent;
      if (elBarre) elBarre.textContent = s ? s.textContent : '';
    }
    function verifier() {
      var principal = zone.querySelector('.product-form__submit');
      var tiroir = document.querySelector('cart-drawer.active, cart-drawer[open]');
      var visible = force || (toujours && !tiroir);
      if (!visible && principal && !tiroir) {
        var r = principal.getBoundingClientRect();
        visible = r.bottom < 0;                        /* le bouton d'achat est passé au-dessus de l'écran */
      }
      if (visible) majContenu();
      barre.classList.toggle('is-visible', visible);
      barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (bouton) bouton.tabIndex = visible ? 0 : -1;
    }
    setInterval(verifier, 350);                         /* pas d'IntersectionObserver : Dawn redessine la zone */
    verifier();

    if (bouton) bouton.addEventListener('click', function () {
      var form = zone.querySelector('form[data-type="add-to-cart-form"]') || zone.querySelector('form[action*="/cart/add"]');
      var o = offreActive();
      var tailles = o && o.querySelector('[data-nky-piece]');
      /* « ajout direct » (réglage du bloc, 08/10/2026) : on met au panier tout de suite, le tiroir s'ouvre */
      if (form && (!tailles || zone.dataset.nkyChoix || barre.hasAttribute('data-nky-sticky-direct'))) { form.requestSubmit(); return; }
      /* pas encore de choix de taille : on ramène la cliente à ses choix plutôt que de commander « S » par défaut */
      if (o) {
        o.scrollIntoView({ behavior: moinsDeMouvement ? 'auto' : 'smooth', block: 'center' });
        o.classList.remove('is-rappel'); void o.offsetWidth; o.classList.add('is-rappel');
        var premier = o.querySelector('[data-nky-piece] select, [data-nky-piece] input');
        if (premier) setTimeout(function () { premier.focus({ preventScroll: true }); }, 450);
      }
    });

    document.addEventListener('shopify:block:select', function (e) { if (barre.contains(e.target) || e.target === barre) { force = true; verifier(); } });
    document.addEventListener('shopify:block:deselect', function () { force = false; verifier(); });
  }

  /* ---------- 3. vidéos clients : lecture dans la vignette, une seule à la fois ---------- */
  function etatCarte(carte, joue) {
    carte.classList.toggle('is-lecture', joue);
    var b = carte.querySelector('[data-nky-ugc-bouton]');
    if (b) b.setAttribute('aria-label', joue ? b.dataset.labelPause : b.dataset.labelLire);
  }
  function basculer(carte) {
    var v = carte.querySelector('video');
    if (!v) return;
    if (!v.paused) { v.pause(); return; }
    document.querySelectorAll('[data-nky-ugc] video').forEach(function (autre) { if (autre !== v && !autre.paused) autre.pause(); });
    v.muted = false;
    if (!v.dataset.nkyBranche) {
      v.dataset.nkyBranche = '1';
      v.addEventListener('play', function () { etatCarte(carte, true); });
      v.addEventListener('pause', function () { etatCarte(carte, false); });
      v.addEventListener('ended', function () { etatCarte(carte, false); v.currentTime = 0; });
      v.addEventListener('timeupdate', function () {
        var barre = carte.querySelector('.nky-ugc__progression i');
        if (barre && v.duration) barre.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
      });
    }
    var essai = v.play();
    if (essai && essai.catch) essai.catch(function () { v.muted = true; v.play(); });   /* navigateur qui refuse le son */
  }
  document.addEventListener('click', function (e) {
    var carte = e.target.closest && e.target.closest('[data-nky-ugc]');
    if (!carte) return;
    var b = carte.querySelector('[data-nky-ugc-bouton]');
    if (b && b.disabled) return;
    basculer(carte);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherSticky); else brancherSticky();
  document.addEventListener('shopify:section:load', brancherSticky);

  /* ---------- pop-up image (guide des tailles, etc.) ---------- */
  function brancherPopups() {
    document.querySelectorAll('[data-nky-popup-img]').forEach(function (btn) {
      if (btn._nkyPopup) return;
      btn._nkyPopup = true;
      var dialog = btn.nextElementSibling;
      if (!dialog || !dialog.matches('[data-nky-popup-dialog]')) return;
      btn.addEventListener('click', function () { dialog.showModal(); requestAnimationFrame(function () { dialog.style.opacity = '1'; }); });
      dialog.querySelector('.nky-popup-img__fermer').addEventListener('click', function () { dialog.style.opacity = '0'; setTimeout(function () { dialog.close(); }, 250); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) { dialog.style.opacity = '0'; setTimeout(function () { dialog.close(); }, 250); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherPopups); else brancherPopups();
  document.addEventListener('shopify:section:load', brancherPopups);

  /* ---------- galerie sur ordinateur : les flèches des vignettes changent l'image ----------
     Chez Dawn, ces flèches ne font que faire défiler la rangée de vignettes : l'image affichée ne bouge pas.
     Ici une flèche montre l'image suivante ou précédente (en boucle) ; Dawn suit avec la vignette active.
     Dawn grise les flèches selon le défilement des vignettes, pas selon l'image affichée : on les garde actives. */
  function brancherFleches() {
    document.querySelectorAll('media-gallery .thumbnail-slider .slider-button').forEach(function (b) {
      if (b.dataset.nkyFleche) return;
      b.dataset.nkyFleche = '1';
      b.removeAttribute('disabled');
      new MutationObserver(function () { if (b.hasAttribute('disabled')) b.removeAttribute('disabled'); })
        .observe(b, { attributes: true, attributeFilter: ['disabled'] });
    });
  }
  document.addEventListener('click', function (e) {
    var fleche = e.target.closest && e.target.closest('media-gallery .thumbnail-slider .slider-button');
    if (!fleche) return;
    var galerie = fleche.closest('media-gallery');
    if (galerie.closest('[data-nky-galerie-fleches]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      pasGalerie(galerie, fleche.name === 'next' ? 1 : -1);
      return;
    }
    var vignettes = Array.prototype.slice.call(galerie.querySelectorAll('.thumbnail-slider [data-target]'))
      .filter(function (v) { return v.offsetParent !== null; });
    if (vignettes.length < 2 || typeof galerie.setActiveMedia !== 'function') return;
    e.preventDefault(); e.stopImmediatePropagation();   /* capture : passe avant le défilement de Dawn */
    var i = vignettes.findIndex(function (v) { var bt = v.querySelector('button'); return bt && bt.hasAttribute('aria-current'); });
    var j = (Math.max(i, 0) + (fleche.name === 'next' ? 1 : -1) + vignettes.length) % vignettes.length;
    galerie.setActiveMedia(vignettes[j].dataset.target, false);
  }, true);
  /* flèches posées sur la grande image (réglage nky_galerie_fleches, 06/10) : photo suivante / précédente, en boucle,
     vignette active mise à jour ; sans setActiveMedia de Dawn, qui ferait remonter la page */
  function pasGalerie(galerie, pas) {
    if (!galerie || !galerie.elements) return;
    var vignettes = Array.prototype.slice.call(galerie.querySelectorAll('.thumbnail-slider [data-target]'))
      .filter(function (v) { return v.offsetParent !== null; });
    var photos = Array.prototype.slice.call(galerie.elements.viewer.querySelectorAll('[data-media-id]'));
    if (photos.length < 2) return;
    var i = -1;
    if (vignettes.length) i = vignettes.findIndex(function (v) { var bt = v.querySelector('button'); return bt && bt.hasAttribute('aria-current'); });
    var ids = vignettes.length ? vignettes.map(function (v) { return v.dataset.target; }) : photos.map(function (p) { return p.dataset.mediaId; });
    if (i < 0) i = Math.max(0, photos.findIndex(function (p) { return p.classList.contains('is-active'); }));
    var j = (i + pas + ids.length) % ids.length;
    var cible = galerie.elements.viewer.querySelector('[data-media-id="' + ids[j] + '"]');
    if (!cible) return;
    photos.forEach(function (p) { p.classList.remove('is-active'); });
    cible.classList.add('is-active');
    if (cible.parentElement) cible.parentElement.scrollTo({ left: cible.offsetLeft, behavior: 'smooth' });
    if (typeof galerie.playActiveMedia === 'function') galerie.playActiveMedia(cible);
    var vignette = galerie.elements.thumbnails && galerie.elements.thumbnails.querySelector('[data-target="' + ids[j] + '"]');
    if (vignette && typeof galerie.setActiveThumbnail === 'function') galerie.setActiveThumbnail(vignette);
  }
  document.addEventListener('click', function (e) {
    var fleche = e.target.closest && e.target.closest('[data-nky-galerie-pas]');
    if (fleche) pasGalerie(fleche.closest('media-gallery'), +fleche.dataset.nkyGaleriePas);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherFleches); else brancherFleches();
  document.addEventListener('shopify:section:load', brancherFleches);

  /* ---------- vidéos des sections : la lecture automatique ne s'arrête pas en route ----------
     Dawn met en pause TOUTES les vidéos de la page (pauseAllMedia) dès que la galerie change d'image ; une vidéo
     en lecture auto arrêtée ainsi ne repart jamais (constaté le 02/10 : un clic sur une flèche figeait la section).
     On relance les vidéos auto des blocs Nakylo quand elles sont à l'écran. Si le navigateur refuse la lecture auto
     (iPhone en économie d'énergie), on montre les commandes pour qu'un toucher la lance. */
  var VIDEO_AUTO = 'video.nky-b-video__lecteur[autoplay], video.nky-b-video--auto';
  var aEcran = new WeakSet();
  function lancer(v) {
    if (!v.paused) return;
    v.muted = true;
    var essai = v.play();
    if (essai && essai.catch) essai.catch(function (e) { if (e && e.name === 'NotAllowedError') v.setAttribute('controls', ''); });
  }
  var guetteur = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { aEcran.add(e.target); lancer(e.target); } else { aEcran.delete(e.target); }
    });
  }, { threshold: 0.2 }) : null;
  function brancherVideos() {
    document.querySelectorAll(VIDEO_AUTO).forEach(function (v) {
      if (v.dataset.nkyAuto) return;
      v.dataset.nkyAuto = '1';
      if (guetteur) guetteur.observe(v);
    });
    var original = window.pauseAllMedia;
    if (typeof original === 'function' && !original.nkyEnveloppe) {
      var enveloppe = function () {
        var r = original.apply(this, arguments);
        document.querySelectorAll(VIDEO_AUTO).forEach(function (v) { if (!guetteur || aEcran.has(v)) lancer(v); });
        return r;
      };
      enveloppe.nkyEnveloppe = true;
      window.pauseAllMedia = enveloppe;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherVideos); else brancherVideos();
  document.addEventListener('shopify:section:load', brancherVideos);

  /* ---------- stories vidéo (blocs nky_story) : le rond ouvre la vidéo en grand ---------- */
  document.addEventListener('click', function (e) {
    var bulle = e.target.closest && e.target.closest('[data-nky-story]');
    if (bulle) {
      var url = bulle.getAttribute('data-nky-story');
      var modal = bulle.closest('.nky-stories') && bulle.closest('.nky-stories').querySelector('[data-nky-story-modal]');
      if (!url || !modal || typeof modal.showModal !== 'function') return;
      var v = modal.querySelector('video');
      v.src = url; modal.showModal();
      var essai = v.play(); if (essai && essai.catch) essai.catch(function () {});
      return;
    }
    var modalOuverte = e.target.closest && e.target.closest('[data-nky-story-modal]');
    if (modalOuverte && (e.target.closest('[data-nky-story-fermer]') || e.target === modalOuverte)) modalOuverte.close();
  });
  document.addEventListener('close', function (e) {
    if (!e.target.matches || !e.target.matches('[data-nky-story-modal]')) return;
    var v = e.target.querySelector('video'); v.pause(); v.removeAttribute('src'); v.load();
  }, true);

  /* rangée de vidéos verticales : avance d'une carte toutes les 4,5 s, revient au début à la fin ; s'arrête dès que le
     visiteur la touche ou la survole, et quand elle sort de l'écran */
  function brancherDefileStories() {
    document.querySelectorAll('[data-nky-stories-defile]:not([data-nky-defile-pret])').forEach(function (r) {
      r.setAttribute('data-nky-defile-pret', '1');
      var arret = false, visible = false;
      ['pointerdown', 'mouseenter', 'focusin', 'wheel'].forEach(function (t) { r.addEventListener(t, function () { arret = true; }, { passive: true }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(r);
      setInterval(function () {
        if (arret || !visible || document.hidden || r.scrollWidth <= r.clientWidth + 4) return;
        var carte = r.querySelector('.nky-story'); if (!carte) return;
        var pas = carte.getBoundingClientRect().width + parseFloat(getComputedStyle(r).columnGap || 10);
        r.scrollTo({ left: r.scrollLeft + r.clientWidth >= r.scrollWidth - 4 ? 0 : r.scrollLeft + pas, behavior: 'smooth' });
      }, 4500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherDefileStories); else brancherDefileStories();
  document.addEventListener('shopify:section:load', brancherDefileStories);

  /* ---------- cadeaux par palier (blocs nky_cadeau) : s'allument selon l'offre choisie ou la quantité ---------- */
  function majCadeaux() {
    document.querySelectorAll('[data-nky-cadeaux]').forEach(function (rangee) {
      var zone = rangee.closest('product-info') || document;
      var total = 1, offre = null;
      zone.querySelectorAll('[data-nky-offre]').forEach(function (o) {
        var r = o.querySelector('.nky-offre__radio'); if (r && r.checked) offre = o;
      });
      if (offre) total = (+offre.dataset.payes || 0) + (+offre.dataset.offerts || 0);
      else { var q = zone.querySelector('input[name="quantity"]'); if (q && +q.value > 0) total = +q.value; }
      rangee.querySelectorAll('[data-nky-palier]').forEach(function (t) {
        t.classList.toggle('is-debloque', total >= (+t.dataset.nkyPalier || 1));
      });
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.nky-offre__radio, input[name="quantity"]')) majCadeaux();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-nky-offre], .quantity__button')) setTimeout(majCadeaux, 0);
  });

  /* ---------- livraison estimée (bloc nky_livraison) : aujourd'hui + N jours, dans la langue de la page ---------- */
  function majDates() {
    var langue = document.documentElement.lang || 'fr';
    var fmt;
    try { fmt = new Intl.DateTimeFormat(langue, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (err) { fmt = new Intl.DateTimeFormat('fr', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function ajouter(n, ouvres) {
      var d = new Date(); d.setHours(12, 0, 0, 0);
      while (n > 0) { d.setDate(d.getDate() + 1); var j = d.getDay(); if (j === 0) continue; if (!ouvres || j !== 6) n--; }
      return d;
    }
    document.querySelectorAll('[data-nky-dates]').forEach(function (el) {
      var ouvres = el.dataset.ouvres === 'true';
      var a = +el.dataset.min || 1, b = Math.max(a, +el.dataset.max || a);
      var t1 = fmt.format(ajouter(a, ouvres)).replace(/\./g, ''), t2 = fmt.format(ajouter(b, ouvres)).replace(/\./g, '');
      el.textContent = a === b ? t1 : t1 + ' – ' + t2;
      var carte = el.closest('.nky-livraison'); if (carte) carte.classList.add('is-pret');
    });
  }
  function brancherAchat() { majCadeaux(); majDates(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherAchat); else brancherAchat();
  document.addEventListener('shopify:section:load', brancherAchat);
  document.addEventListener('shopify:block:select', brancherAchat);

  /* ---------- bandeau d'offre (bloc nky_promo, 05/10/2026) ----------
     Le bouton choisit l'offre visée (lot de 2…), la montre et l'allume une fois ; l'autocollant « photo »
     est déplacé en haut à gauche de la galerie principale. */
  function brancherPromo() {
    document.querySelectorAll('[data-nky-promo]').forEach(function (p) {
      if (p.dataset.nkyPret) return;
      p.dataset.nkyPret = '1';
      var zone = p.closest('product-info') || p.closest('.shopify-section') || document;
      var bouton = p.querySelector('[data-nky-promo-choisir]');
      if (bouton) bouton.addEventListener('click', function () {
        var o = zone.querySelectorAll('.nky-offre')[(+p.dataset.offre || 2) - 1];
        if (!o) return;
        var r = o.querySelector('.nky-offre__radio');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        o.scrollIntoView({ behavior: doux ? 'smooth' : 'auto', block: 'center' });
        o.classList.remove('nky-offre--appel'); void o.offsetWidth; o.classList.add('nky-offre--appel');
      });
    });
    /* autocollant photo (avec ou sans bandeau) : posé dans la 1re image, il défile avec elle */
    document.querySelectorAll('[data-nky-promo-photo]').forEach(function (photo) {
      var zone = photo.closest('product-info') || photo.closest('.shopify-section') || document;
      var galerie = zone.querySelector('[id^="GalleryViewer-"]') || document.querySelector('[id^="GalleryViewer-"]');
      var premiere = galerie && galerie.querySelector('[data-media-id]');
      if (!premiere || premiere.contains(photo)) return;
      var ancien = premiere.querySelector('.nky-promo-photo');
      if (ancien) ancien.remove();
      premiere.appendChild(photo); photo.hidden = false; premiere.classList.add('nky-a-promo');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherPromo); else brancherPromo();
  document.addEventListener('shopify:section:load', brancherPromo);
})();

/* Carrousel d'avis de la zone d'achat (snippet nky-achat-avis-defile) : un avis par écran, avance toutes les
   5 s quand il est à l'écran, points cliquables, glisser au doigt. Survol = pause ; un toucher ou un clic du
   visiteur l'arrête pour de bon. Pas de défilement auto si le visiteur a demandé moins d'animations. */
(function () {
  'use strict';
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function brancher(r) {
    if (r.dataset.nkyPret) return;
    r.dataset.nkyPret = '1';
    var piste = r.querySelector('[data-nky-piste]');
    var points = [].slice.call(r.querySelectorAll('[data-nky-point]'));
    var cartes = piste ? [].slice.call(piste.children) : [];
    if (cartes.length < 2) return;
    var i = 0, survol = false, arrete = calme, visible = false, minuteur = null;
    function maj() {
      points.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function aller(n) {
      i = (n + cartes.length) % cartes.length;
      piste.scrollTo({ left: cartes[i].offsetLeft - cartes[0].offsetLeft, behavior: calme ? 'auto' : 'smooth' });
      maj();
    }
    function relancer() {
      clearInterval(minuteur);
      if (arrete) return;
      minuteur = setInterval(function () { if (visible && !survol && !document.hidden) aller(i + 1); }, 5000);
    }
    var attente = null;
    piste.addEventListener('scroll', function () {
      clearTimeout(attente);
      attente = setTimeout(function () {
        var n = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        if (n !== i && n >= 0 && n < cartes.length) { i = n; maj(); }
      }, 80);
    }, { passive: true });
    points.forEach(function (p, k) { p.addEventListener('click', function () { arrete = true; relancer(); aller(k); }); });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) {
      piste.addEventListener(t, function () { arrete = true; relancer(); }, { passive: true });
    });
    r.addEventListener('mouseenter', function () { survol = true; });
    r.addEventListener('mouseleave', function () { survol = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.5 }).observe(r);
    } else { visible = true; }
    maj();
    relancer();
  }
  function tout() { document.querySelectorAll('[data-nky-avis-defile]').forEach(brancher); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
  if ('MutationObserver' in window) {
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () { prevu = false; tout(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* Galerie produit : prépare les photos suivantes pour qu'un glissement n'affiche jamais une case vide.
   Après le chargement de la page (la 1re photo garde la priorité), la 2e photo est chargée en tâche de fond ;
   puis à chaque changement de photo (glissement, flèches, vignette), les 2 suivantes passent en chargement
   immédiat. Rien de plus n'est téléchargé avant l'affichage de la page. */
(function () {
  'use strict';
  function preparer(galerie, combien) {
    var items = [].slice.call(galerie.querySelectorAll('.product__media-item'));
    if (!items.length) return;
    var actif = 0;
    items.forEach(function (li, k) { if (li.classList.contains('is-active')) actif = k; });
    if (galerie.scrollLeft > 0 && galerie.clientWidth) {
      actif = Math.max(actif, Math.round(galerie.scrollLeft / galerie.clientWidth));
    }
    for (var k = actif + 1; k <= actif + combien && k < items.length; k++) {
      var img = items[k].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }
  }
  function brancher() {
    document.querySelectorAll('[id^="Slider-Gallery-"]').forEach(function (g) {
      if (g.dataset.nkyPrepare) return;
      g.dataset.nkyPrepare = '1';
      var auRepos = window.requestIdleCallback || function (f) { setTimeout(f, 200); };
      var depart = function () { auRepos(function () { preparer(g, 1); }); };
      if (document.readyState === 'complete') depart(); else window.addEventListener('load', depart, { once: true });
      var attente = null;
      g.addEventListener('scroll', function () {
        clearTimeout(attente);
        attente = setTimeout(function () { preparer(g, 2); }, 60);
      }, { passive: true });
      if ('MutationObserver' in window) {
        new MutationObserver(function (changements) {
          var change = changements.some(function (m) {
            return m.target.classList && m.target.classList.contains('is-active') !== /\bis-active\b/.test(m.oldValue || '');
          });
          if (change) preparer(g, 2);
        }).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
  document.addEventListener('shopify:section:load', brancher);
})();

/* Minuteur d'offre de la zone d'achat (bloc nky_minuteur, 09/10/2026). Échéance = vraie date de fin (heure de Paris) ou
   minuit chez le visiteur (offre du jour). Sans échéance valable, le bloc reste caché aux clients (visible dans l'éditeur). */
(function () {
  function parisVersMs(txt) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((txt || '').trim());
    if (!m) return NaN;
    var essai = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59));
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(essai)).forEach(function (x) { p[x.type] = x.value; });
      var vuAParis = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
      return essai - (vuAParis - essai);
    } catch (e) { return essai - 3600000; }
  }
  function echeance(el) {
    if (el.dataset.mode === 'minuit') { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
    return parisVersMs(el.dataset.fin);
  }
  var deux = function (n) { return (n < 10 ? '0' : '') + n; };
  function tic() {
    document.querySelectorAll('[data-nky-minuteur]').forEach(function (el) {
      var reste = echeance(el) - Date.now();
      if (!(reste > 0)) {
        if (el.hasAttribute('data-editeur')) { el.hidden = false; reste = 0; } else { el.hidden = true; return; }
      }
      el.hidden = false;
      var s = Math.floor(reste / 1000), h = Math.floor(s / 3600);
      el.querySelector('[data-h]').textContent = deux(h);
      el.querySelector('[data-m]').textContent = deux(Math.floor(s % 3600 / 60));
      el.querySelector('[data-s]').textContent = deux(s % 60);
    });
  }
  tic(); setInterval(tic, 1000);
  document.addEventListener('shopify:section:load', tic);
})();
